export default __webpack_public_path__ + "static/media/locations.d01c8cfb.svg";